import { TimeOptionsSchema } from "@/packages/shared/src/models/scheduling-availability";
import { Appointment, AppointmentType } from "@/src/models/appointment";
import { AppointmentSlot } from "@/src/models/comms/scheduling-schemas";
import { Location } from "@/src/models/location";
import { Practitioner } from "@/src/models/practitioner";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getPatientAppointments(patientId: string): Promise<Appointment[]> {
  return fetchJSON<Appointment[]>(`/api/scheduling/appointments/${patientId}`);
}

export interface IsEstablishedPatientResponse {
  isEstablishedPatient: boolean;
}

export async function isEstablishedPatient(patientId: string): Promise<IsEstablishedPatientResponse> {
  return fetchJSON<IsEstablishedPatientResponse>(`/api/scheduling/patients/${patientId}/established`);
}

export async function getPractitioners(patientId: string): Promise<Practitioner[]> {
  return fetchJSON<Practitioner[]>(`/api/scheduling/practitioners/${patientId}`);
}

export async function getLocations(patientId: string): Promise<Location[]> {
  const url = `/api/scheduling/locations?patientId=${encodeURIComponent(patientId)}`;

  return fetchJSON<Location[]>(url);
}

export async function getSchedulingCapabilities(): Promise<{
  emrSchedulingSupported: boolean;
  locationBasedScheduling: boolean;
}> {
  return fetchJSON<{ emrSchedulingSupported: boolean; locationBasedScheduling: boolean }>(
    "/api/scheduling/capabilities"
  );
}

export async function checkAvailability(
  patientId: string,
  appointmentType: AppointmentType,
  practitionerIds: string[],
  locationIds: string[],
  scheduleAvailability: TimeOptionsSchema
): Promise<AppointmentSlot[]> {
  return fetchJSON<AppointmentSlot[]>(`/api/scheduling/appointments/availability`, {
    method: "POST",
    body: JSON.stringify({
      patientId,
      practitionerIds,
      locationIds,
      appointmentType,
      scheduleAvailability,
    }),
  });
}
